<template>
  <div class="TipsPage">
    <img class="img" src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_info.png">
    <div class="info">{{infoText}}</div>
  </div>
</template>
<script>
export default {
  name: "TipsPage",
  data: function () {
    return {
      infoText:"您未同意服务协议，服务暂不可用",
    };
  },
}
</script>

<style scoped lang="scss">
.TipsPage{
  padding:0 12px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 231px;
  box-sizing: border-box;
  .img{
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
  }
  .info{
    color: var(--Tokens-Text-primary, #28282D);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
}
</style>
